export const USER_UMBRELLAS_REQUESTED = 'USER_UMBRELLAS_REQUESTED'
export const USER_UMBRELLAS_RECEIVED = 'USER_UMBRELLAS_RECEIVED'
export const UMBRELLA_REQUESTED = 'UMBRELLA_REQUESTED'
export const UMBRELLA_RECEIVED = 'UMBRELLA_RECEIVED'
